// pages/Personal Attendance/YtdFtoReport.js
//
// Legacy menu: "Review YTD FTO Status"
// Shows dept FTOs filtered to a chosen year (year selector in toolbar).
// Backend: GET /api/fto/dept?year=YYYY

import React from "react";
import DeptAttendanceTable from "./components/DeptAttendanceTable";
import { getFtoDept } from "./ftoService";

const YtdFtoReport = () => (
    <DeptAttendanceTable
        title="YTD FTO Status"
        subtitle="Dept FTOs for the selected year"
        kind="FTO"
        fetcher={getFtoDept}
        showFutureToggle={false}
        showYearSelector={true}
        breadcrumb={[{ label: "Attendance", to: "/workflows?wf=pac" }, { label: "YTD FTO Status" }]}
    />
);

export default YtdFtoReport;
